/**
 * Admin Feature Overrides API
 * მომხმარებლის ლიმიტების მართვის API
 */

import { get, post, put, del } from '@aiia/portal-core';

export interface FeatureCodeInfo {
  code: string;
  displayName: string;
  description: string;
  isBooleanFeature: boolean;
}

export interface FeatureOverrideResponse {
  id: string;
  userId: string;
  featureCode: string;
  overrideValue: number;
  unlimited: boolean;
  reason: string | null;
  expiresAt: string | null;
  createdAt: string;
  createdBy: string | null;
}

export interface FeatureLimitInfo {
  featureCode: string;
  displayName: string;
  planValue: number;
  effectiveValue: number;
  hasOverride: boolean;
  isUnlimited: boolean;
  isBooleanFeature: boolean;
}

export interface UserFeatureLimitsResponse {
  userId: string;
  planCode: string;
  planName: string;
  limits: FeatureLimitInfo[];
}

export interface CreateFeatureOverrideRequest {
  featureCode: string;
  customValue: number;
  isUnlimited?: boolean;
  reason?: string;
  expiresAt?: string;
}

export interface UpdateFeatureOverrideRequest {
  customValue: number;
  isUnlimited?: boolean;
  reason?: string;
  expiresAt?: string;
}

// Get all available feature codes
export const getFeatureCodes = () =>
  get<FeatureCodeInfo[]>('/admin/feature-codes');

// Get user feature limits (plan + overrides)
export const getUserFeatureLimits = (userId: string) =>
  get<UserFeatureLimitsResponse>(`/admin/users/${userId}/feature-limits`);

// Get user overrides only
export const getUserOverrides = (userId: string) =>
  get<FeatureOverrideResponse[]>(`/admin/users/${userId}/feature-overrides`);

// Create feature override
export const createFeatureOverride = (userId: string, data: CreateFeatureOverrideRequest) =>
  post<FeatureOverrideResponse>(`/admin/users/${userId}/feature-overrides`, data);

// Update feature override
export const updateFeatureOverride = (userId: string, featureCode: string, data: UpdateFeatureOverrideRequest) =>
  put<FeatureOverrideResponse>(`/admin/users/${userId}/feature-overrides/${featureCode}`, data);

// Delete feature override
export const deleteFeatureOverride = (userId: string, featureCode: string) =>
  del(`/admin/users/${userId}/feature-overrides/${featureCode}`);
